<template>
  <div class="admin-content">
    <div class="content-main">
      <div class="main-header">
        <div class="header-title">
          <span>PLAYER INSTANCE EDIT</span>
        </div>
        <div class="header-sub-title">
          <span>{{ instance.general.name }}</span>
        </div>
      </div>
      <div class="" v-loading="loadingGet">
        <el-tabs tab-position="left">
          <el-tab-pane label="General">
            <TabGeneral role="customer" v-bind:actionItem="instance" />
          </el-tab-pane>
          <el-tab-pane label="Features">
            <TabFeatures role="customer" v-bind:actionItem="instance" />
          </el-tab-pane>
          <el-tab-pane label="Products">
            <TabProducts role="customer" v-bind:actionItem="instance" />
          </el-tab-pane>
          <el-tab-pane label="Sources">
            <TabSources role="customer" v-bind:actionItem="instance" />
          </el-tab-pane>
          <el-tab-pane label="Images">
            <TabImages role="customer" v-bind:actionItem="instance" />
          </el-tab-pane>
          <el-tab-pane label="Buy Button">
            <TabBuyButton role="customer" v-bind:actionItem="instance" />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import TabGeneral from '@/components/instances/TabGeneral'
import TabFeatures from '@/components/instances/TabFeatures'
import TabProducts from '@/components/instances/TabProducts'
import TabSources from '@/components/instances/TabSources'
import TabImages from '@/components/instances/TabImages'
import TabBuyButton from '@/components/instances/TabBuyButton'

export default {
  name: 'ClientProductEdit',
  components: {
    TabGeneral,
    TabFeatures,
    TabProducts,
    TabSources,
    TabImages,
    TabBuyButton
  },
  data () {
    return {
      instanceId: this.$route.params.id,
      instance: { general: {} },
      loadingGet: false
    }
  },
  created () {
    this.getInstance()
  },
  mounted () {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    getInstance: function () {
      if (this.loadingGet) return
      this.loadingGet = true
      const url = `/api/v1/atk_player/instances/${this.instanceId}`
      const that = this
      this.$service.get(url).then(function (res) {
        if (res.code === 200) {
          that.instance = res.data
          if (!that.instance.features.display_price) {
            that.instance.features.display_price = {
              is_enable: 1
            }
          }
        } else {
          console.error('getInstance', res.msg)
        }
        that.loadingGet = false
      }).catch(function (err) {
        console.error('getInstance', err.msg)
        that.loadingGet = false
      })
    }
  }
}
</script>
